export default __webpack_public_path__ + "static/media/img1.bb92518b.webp";